import React, { Component } from 'react';
import PopupMenu from './PopupMenu';
import EdgeLocation from '../ui_core/EdgeLocation';
import './PlotMoreInformation.css';
import ParameterErrors from '../errors/ParameterErrors';
import SubMenuHeader from './SubMenuHeader';
import ClickedOffManager from '../ui_core/ClickedOffManager';
import MenuType from '../enums/MenuType';
import TabPanel from './TabPanel';
import PlotMoreInformationFloorPlans from './PlotMoreInformationFloorPlans';
import PlotMoreInformationGallery from './PlotMoreInformationGallery';
import PlotMoreInformationOverview from './PlotMoreInformationOverview';
import PropertyBindingFactory from '../mvvm/PropertyBindingFactory';
import enableBindingToOthers from '../mvvm/enableBindingToOthers';
import PlotMoreInformationType from '../enums/PlotMoreInformationType';
import AssetsManager from '../assets_management/AssetsManager';
import GoogleAnalytics from '../google/GoogleAnalytics';
const {throwNotProvided}=ParameterErrors;
export default class PlotMoreInformation extends Component {
	constructor(props){
		super(props);
		const {onExpandImage, addFavourite, removeFavourite, showStreetView, configuration}=props;
		this._configuration = configuration;
		this._callbackExpandImage=onExpandImage;
		this._callbackAddFavourite = addFavourite;
		this._callbackRemoveFavourite = removeFavourite;
		this._callbackShowStreetView = showStreetView;
		this._subMenuHeader = React.createRef();
		this._elementRef = React.createRef();
		this._tabPanelRef= React.createRef();
		this._overview = React.createRef();
		this._gallery = React.createRef();
		this._floorPlans = React.createRef();
		this._callbackClose = null;
		this.show = this.show.bind(this);
		this.hide = this.hide.bind(this);
		this._getTitle = this._getTitle.bind(this);
		this._getPanelsViewPort = this._getPanelsViewPort.bind(this);
		this._disposeClickedOffHandle=this._disposeClickedOffHandle.bind(this);
		this._iMenuManager = null;
		this._clickedOffManager = new ClickedOffManager({elementRef:this._elementRef, hide:this.hide});
		this._releasePlotActiveHandle= this._releasePlotActiveHandle.bind(this);
		this._handleShowStreetView = this._handleShowStreetView.bind(this);
		this._handleTabSetActive = this._handleTabSetActive.bind(this);
		this._currentPlotActiveHandle = null;
		this._currentPlotMoreInformationType = PlotMoreInformationType.OVERVIEW;
		this.state={plot:null, visible:false};
	}
	show(site, plot, configuration, plotMoreInformationType){
		this.setState({plot:this._plot, visible:true});
		this._clickedOffManager.register();
		if(plot)this._plot = plot;
		if(site)this._site = site;
		if(this._plot){
			this._releasePlotActiveHandle();
			this._currentPlotActiveHandle =  this._plot.unit.takeActiveHandle();
		}
		if(plotMoreInformationType&&plot){
			this._tabPanelRef.current.setActive(plotMoreInformationType);
			switch(plotMoreInformationType){
				case PlotMoreInformationType.FLOOR_PLANS:
					GoogleAnalytics.logEvent('viewedFloorPlans', {plotNumber:plot.number});
					break;
				case PlotMoreInformationType.GALLERY:
					GoogleAnalytics.logEvent('viewedGallery', {plotNumber:plot.number});
					break;
			}
		}
		else 
		{
			if(this._currentPlotMoreInformationType){
				this._handleTabSetActive(this._currentPlotMoreInformationType);
			}
		}
		this._iMenuManager.showMe(this);
	}
	hide(){
		this._clickedOffManager.dispose();
		this.setState({visible:false});
		this._releasePlotActiveHandle();
		this._iMenuManager.close();
	}
	get menuType(){
		return MenuType.PLOT_MORE_INFORMATION;
	}
	setIMenuManager(value){
		this._iMenuManager = value;
		this._subMenuHeader.current.setIMenuManager(value);
	}
	_releasePlotActiveHandle(){
		if(!this._currentPlotActiveHandle)return;
		this._currentPlotActiveHandle.dispose();
		this._currentPlotActiveHandle=null;
	}
	_getTitle(plot){
		if(this._configuration.fullScreenGalleryAndFloorPlans)return '';
		return `More about Plot ${plot?.number}`;
	}
	_getPanelsViewPort(){
		 const element = this._elementRef.current;
		 if(element===undefined||element===null)return 1;
		 return [element.offsetWidth, element.offsetHeight];
	}
	_disposeClickedOffHandle(){
		this._clickedOffHandle&&this._clickedOffHandle.dispose();
	}
	_handleShowStreetView(e){
		this._callbackShowStreetView();
		this.hide();
	}
	_handleTabSetActive(tabKey){
		this._currentPlotMoreInformationType =tabKey;
		switch(tabKey){
			case PlotMoreInformationType.GALLERY:
				this._gallery.current.load(this._site, this._plot);
			break;
			case PlotMoreInformationType.FLOOR_PLANS:
				this._floorPlans.current.load(this._site, this._plot);
			break;
			case PlotMoreInformationType.OVERVIEW:
				this._overview.current.load(this._site, this._plot);
			break;
		}
	}
	render(){
		let className="plot-more-information menu";
		if(this._configuration.fullScreenGalleryAndFloorPlans)
			className+=" full-screen-gallery-and-floor-plans";
		if(this.state.visible)
			className+=" visible";
		if(this.state.visible&&this._configuration.fullScreenGalleryAndFloorPlans&&(
			(this._currentPlotMoreInformationType===PlotMoreInformationType.GALLERY)||
			(this._currentPlotMoreInformationType===PlotMoreInformationType.FLOOR_PLANS)
		)){
			document.body.classList.add('full-screen-gallery-or-floor-plans-showing');
		}else{
			document.body.classList.remove('full-screen-gallery-or-floor-plans-showing');
		}
		return (
	<div className={className }ref={this._elementRef}>
		<SubMenuHeader ref={this._subMenuHeader} title={this._getTitle(this.state.plot)}></SubMenuHeader>
		<TabPanel defaultActiveTabIndex={0} ref={this._tabPanelRef} onSetActive={this._handleTabSetActive}>
			<PlotMoreInformationOverview ref={this._overview} plot={this.state.plot} tabKey={PlotMoreInformationType.OVERVIEW}
				addFavourite = {this._callbackAddFavourite} removeFavourite ={this._callbackRemoveFavourite} 
				showStreetView={this._handleShowStreetView} configuration={this._configuration}></PlotMoreInformationOverview>
			<PlotMoreInformationGallery ref={this._gallery} tabKey={PlotMoreInformationType.GALLERY} 
			getViewPort = {this._getPanelsViewPort} onExpandImage ={this._callbackExpandImage}
			configuration={this._configuration}></PlotMoreInformationGallery>
			<PlotMoreInformationFloorPlans ref={this._floorPlans} tabKey={PlotMoreInformationType.FLOOR_PLANS}
			getViewPort = {this._getPanelsViewPort} onExpandImage ={this._callbackExpandImage}
			configuration={this._configuration}></PlotMoreInformationFloorPlans>
		</TabPanel>
	</div>)
	}
}